// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","grey":"#707070","medium-grey":"#9f9f9f","light-grey":"#d4d4d4","tooltipLayout":"_2vEMKeMSQ-6JugvLJs_kh","tooltipRow":"dOpDS5wpEEz5UN-gCRs2L","tooltipLineIcon":"_3irzuwxFSOzDJNQuP9O_z9","tooltipTitle":"_3Qkydul-jV8VrcAvoO_Mbu","tooltipLabel":"_3kt4PojcO9LLUz4AMJnon3","tooltipDescription":"V25z9GD0nPugppfYENVsf","tooltipListElement":"_34ruJwd0x1HdG056b1IMPG","tooltip":"Qc71qPy5_ItTuaJcihjiF","tooltipIcons":"saf52uXfSYD7viLYa4FEx","tooltipPoints":"_209UMDdTakmm-CcMAn1imH","flag":"sXfPMpuwz3Y7M48kVf_8A"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Tooltip/Layout/Layout.css
// module id = 556
// module chunks = 0